import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Loader from "../components/common/Loader";
import ErrorState from "../components/common/ErrorState";
import Badge from "../components/common/Badge";
import universityService from "../services/universityService";
import studentService from "../services/studentService";
import StudentTable from "../components/student/StudentTable";
import { formatDate } from "../utils/format";

export default function UniversityDetails() {
  const { id } = useParams();
  const [uni, setUni] = useState(null);
  const [students, setStudents] = useState([]);
  const [state, setState] = useState("loading");

  function load() {
    setState("loading");
    Promise.all([universityService.get(id), null])
      .then(([uRes]) => {
        setUni(uRes.data);
        return studentService.list({ university_name: uRes.data.name, limit: 10 });
      })
      .then((sRes) => {
        setStudents(sRes.data || []);
        setState("ready");
      })
      .catch(() => setState("error"));
  }

  useEffect(load, [id]); // eslint-disable-line

  if (state === "loading") return <div className="pm-page"><Loader label="Loading campus" /></div>;
  if (state === "error") return <div className="pm-page"><ErrorState onRetry={load} /></div>;

  return (
    <div className="pm-page">
      <Link to="/admin/universities" className="pm-back-link">← All campuses</Link>
      <header className="pm-page__header">
        <div>
          <span className="pm-eyebrow">Campus</span>
          <h1>{uni.name}</h1>
        </div>
        <div className="pm-page__actions">
          <Link to={`/admin/universities/${uni.id}/rounds`} className="pm-btn pm-btn--primary pm-btn--sm">
            Manage rounds →
          </Link>
          <Badge active={!!uni.is_active} />
        </div>
      </header>

      <div className="pm-detail-grid">
        <div className="pm-card">
          <h3>Overview</h3>
          <dl className="pm-dl">
            <div><dt>Location</dt><dd>{uni.location || "—"}</dd></div>
            <div><dt>Hiring type</dt><dd>{uni.type_of_hire || "—"}</dd></div>
            <div><dt>Window</dt><dd>{formatDate(uni.start_date)} – {formatDate(uni.end_date)}</dd></div>
            <div><dt>Created</dt><dd>{formatDate(uni.created_date)}</dd></div>
            <div><dt>Updated</dt><dd>{formatDate(uni.updated_date)}</dd></div>
          </dl>
        </div>
        <div className="pm-card">
          <h3>Applicants</h3>
          <div className="pm-stat-mini-grid">
            <div><span>{uni.student_count}</span><label>Total</label></div>
            <div><span>{uni.active_student_count}</span><label>Active</label></div>
          </div>
        </div>
      </div>

      <div className="pm-card" style={{ marginTop: 24 }}>
        <div className="pm-card__header">
          <h3>Applications from this campus</h3>
        </div>
        <StudentTable students={students} loading={false} />
      </div>
    </div>
  );
}
